export default {
  BASE_API: process.env.REACT_APP_BASE_API,
  NODE_ENV: process.env.REACT_APP_ENVIRONMENT,
};
